import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import {Provider} from "react-redux";
import store from "./DAL/store"
import {TABLET_BREAKPOINT_END} from "../../domain/animations/animations-provider";
import YotpoPreview from "../yotpo-preview/yotpoPreview";
import YotpoPreviewList from "../yotpo-preview/yotpoPreviewList";
import { getABTest, sendABTestAnalytics } from '../../domain/abtest/abtest-provider';
import { getGdprCookie, getGdprError } from '../gdpr/domain/gdpr-provider';

/**
 * entry point
 */
export const init = () => {
    const $root = document.getElementById('subscriptions-app');
    if (!$root) return;

    // Send 'SBSSideBySide' a/b test only on subscription page
    const abtestSBSSideBySide = getABTest('SBSSideBySide');
    if(abtestSBSSideBySide && abtestSBSSideBySide.isActive) {
        sendABTestAnalytics(abtestSBSSideBySide);
    }

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {
    // rewriteWavesalias();

    init();
    const $yotpo = document.getElementById('yotpo-reviews');
    if($yotpo) {
        YotpoPreview.Init();
    }

    const gdpr = getGdprCookie();
    const isFunctional = gdpr.IsFunctional;

    const $yotpoList = document.querySelectorAll('[yotpo-block]') as unknown as HTMLElement[];
    $yotpoList.forEach(($yotpoBlock)  => {
        //if(cnt++ > 0)
        //    return;
        if(!$yotpoBlock || !$yotpoBlock.textContent)
            return;

        const yotpoMainWidget:any = $yotpoBlock.getElementsByClassName('yotpo-main-widget');
        if(!yotpoMainWidget || !yotpoMainWidget[0])
            return;

        const yotpoApiKey = document.getElementById('yotpo-api-key')?.textContent;
        const previewImageDiv:any = $yotpoBlock.querySelectorAll('[yotpo-previewimage]');

        let  previewImage = null;
        let  productTitle = null;
        if(previewImageDiv && previewImageDiv[0] && previewImageDiv[0].children && previewImageDiv[0].children[0]) {
            previewImage = previewImageDiv[0].children[0].src;
            if(previewImage && previewImage !== '')
                previewImage = previewImage.split('?')[0];
            productTitle = previewImageDiv[0].children[0].getAttribute("data-yotpo-title");
        }

        const skunumberDiv:any = $yotpoBlock.querySelectorAll('[yotpo-skunumber]');
        let  skunumber = null;
        if(skunumberDiv && skunumberDiv[0] && skunumberDiv[0].textContent)
            skunumber = skunumberDiv[0].textContent;

        //console.log(`previewImage:${previewImage}, skunumber:${skunumber}`);
        YotpoPreviewList.Init(yotpoMainWidget[0], yotpoApiKey, skunumber, previewImage,productTitle);

        if(!isFunctional) {
            $yotpoBlock.innerHTML = getGdprError();
            $yotpoBlock.classList.remove('hidden');
            $yotpoBlock.style.margin = '50px auto 10px auto';
            $yotpoBlock.style.width = 'fit-content';
        }
    });

});
/**
 * On Scroll Event for Explore plan panel on mobile
 */
document.addEventListener('scroll', () => {

    if(window.screen.width <= TABLET_BREAKPOINT_END){
        let codeMirrorContainer = document.getElementById("code-mirror-container");
        let explorePlanContainer = document.getElementById("explore-plan-container");

        if(codeMirrorContainer !== null){
            const rect = codeMirrorContainer.getBoundingClientRect();
            if(rect.top <= 0 && explorePlanContainer !== null && explorePlanContainer.classList.contains("hidden")){
                explorePlanContainer.classList.remove("hidden");
            }else if(rect.top > 0 && explorePlanContainer !== null && !explorePlanContainer.classList.contains("hidden")){
                explorePlanContainer.classList.add("hidden");
            }
        }
    }

});
